import type {
  CostValuesView,
  RawCostValue,
} from 'lumen/utils/net-revenue/cost/types';

/**
 * Pure mapping between the backend's flat `cost_values` array and the UI-stable
 * `CostValuesView`. This is the single place that shape lives; if the BE renames
 * a field, only this file (and its test) changes. Mirrors the `flattenMoney`
 * helper pattern in `serializer-helpers.ts`.
 *
 * Only simple commission values are modelled today; weekday / lead-time windows
 * arrive with the advanced entry mode (PIN-1246).
 */

export function costValuesToView(raw: RawCostValue[]): CostValuesView {
  return { value: raw[0]?.value ?? null };
}

export function viewToCostValues(view: CostValuesView): RawCostValue[] {
  if (view.value === null) {
    return [];
  }
  return [
    {
      leadtime_end: null,
      leadtime_start: null,
      value: view.value,
      weekday: null,
    },
  ];
}
